module.exports = __webpack_public_path__ + "img/close-square-off.288d55ba.svg";